import { MyCardsCollection } from './MyCardsCollection';
export default MyCardsCollection;
